/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMusicFestivalTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMusicFestival,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Rock Out!",
    "Music Festival Awaits!",
    "Groove to the Beat!",
  ],
  title: "Music Festival",
  description: "Organize a fun music festival.",
  longDescription:
    "Gather your friends for an amazing music festival! Choose a date, decide on artists to feature, and plan activities for the festival!",
  emoji: "🎶",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Music Festival",
          emoji: "🎶",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the music festival?",
          emoji: "📅",
          completeAction: {
            question: "Decide on artists to feature?",
            description:
              "Which artists do we want to showcase at the festival?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What artists should we include?",
                emoji: "🎤",
                completeAction: {
                  question: "Decide on activities for the festival?",
                  description:
                    "What activities should we include during the festival?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Music!",
    outroDescription: "Your music festival plans are set! Enjoy the vibes!",
  },
};
